import { Button, Col, Image, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { fetcher, processReq } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { productTabConfig } from '../ProductsTab';
import { useDispatch, useSelector } from 'react-redux';
import { setProduct, setProductsList } from '../../../store/slices/productSlice';
import SearchComponent from '../../../components/SearchComponent';

function ProductList({onSwitchTab}) {
    const productsDataFetcher = useSWR({method: GET, url: API_ROUTE + '/products'} , fetcher);
    const products = useSelector(state => state.productSlice);
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);
    const [isAnalyticsLoading, setIsAnalyticsLoading] = useState(false);

    const editProduct = (data) => {
        dispatch(setProduct(data))
        onSwitchTab(productTabConfig.ADD_PRODUCT, data);
    }

    const manageInventory = (data) => {
      dispatch(setProduct(data))
      onSwitchTab(productTabConfig.PRODUCT_INVENTORY, data);
  }

    useEffect(() => {
      if (productsDataFetcher.data?.data) {
        dispatch(setProductsList(productsDataFetcher.data.data));
      }
    }, [productsDataFetcher.data?.data])

    const onFilter = (filteredData) => {
      setFilteredData(filteredData);
    }

    const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          filterSearch: true,
          // onFilter: (value, record) => record.name.startsWith(value),
          filters: [
            {
              text: "Name",
              value: 'name'
            }
          ]
        },
        {
          title: 'Image',
          key: 'image',
          render: (_, record) => (
              <>
                  <div>
                      <Image src={record.imageUrl} width={100} />
                  </div>

              </>
          )
      },
        // {
        //   title: 'Description',
        //   dataIndex: 'description',
        //   key: 'description',
        // },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right',
            render: (_, record) => (
                <>
                    <div>
                        <Button onClick={() => editProduct(record)}>Amend</Button>
                        <Button onClick={() => manageInventory(record)}>Inventory</Button>
                        {/* <Button onClick={() => loadAnalytics(record)}>Analytics</Button> */}
                    </div>

                </>
            )
        }
      ];

      const loadAnalytics = async (record) => {
        const result = await processReq(GET, API_ROUTE + "/products/" + record.id);
        console.log(record, result)
      }
    
      return (
        <Row gutter={[16, 16]}>
          <SearchComponent onFilter={onFilter} masterData={products.productList} filterByKeys={['name', 'price']} />

          <Col span={24} className='overflow-x-auto'>
            <Table rowClassName={'h-50'} columns={columns} dataSource={filteredData} pagination={true} loading={productsDataFetcher.isLoading} />
          </Col>
        </Row>
      );
}

export default ProductList